document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function () {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    customProduct();
});
$(document).ready(function () {
    customProduct();
})

function customProduct() {
    $('.product').each(function () {
        if ($(this).closest('#productsTop').length) {
            return; 
        }

        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }
        if ($(this).find(".price-final").length) {
            $(this).find(".price-final").append($(this).find(".availability"));
        }
    });
}


